import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {ContactEditModalComponent} from "./contact/contact-edit-modal/contact-edit-modal.component";
import {ContactListComponent} from "./contact/contact-list/contact-list.component";
import {
  HierarchyNodeEditModalComponent
} from "./hierarchy-nodes/hierarchy-node-edit-modal/hierarchy-node-edit-modal.component";
import {SpecLinesEditComponent} from "./spec/spec-lines-edit/spec-lines-edit.component";
import {CommonSharedModule} from "common-shared";
import {ActionBarModule, MesCommonModule, SystemModule} from "web-shared";
import {CheckboxModule} from "primeng/checkbox";
import {FormsModule} from "@angular/forms";
import {TranslocoModule} from "@jsverse/transloco";
import {NgArrayPipesModule} from "ngx-pipes";
import {TableModule} from "primeng/table";
import {FilterAndGroupAndSortSpecsPipe} from "./spec/spec-lines-edit/filter-and-group-and-sort-specs";
import {NgbDropdownModule} from "@ng-bootstrap/ng-bootstrap";
import {IsSpecDuplicatePipe} from "./spec/spec-lines-edit/is-spec-duplicate.pipe";
import {IsSpecWithLocalizationsPipe} from "./spec/spec-lines-edit/is-spec-with-localizations.pipe";
import {InlineSVGModule} from "ng-inline-svg-2";
import {
  PropertyMappingEditorModalComponent
} from "./property-mapping/property-mapping-editor-modal/property-mapping-editor-modal.component";
import {NgSelectModule} from "@ng-select/ng-select";
import {LocalizationListComponent} from "./localizations/localization-list/localization-list.component";
import {LocalizationEditComponent} from "./localizations/localization-edit/localization-edit.component";
import { ConfirmFinalModificationModalComponent } from './confirm-final-modification-modal/confirm-final-modification-modal.component';
import { IsSpecValueInvalidPipe } from './spec/spec-lines-edit/is-spec-value-invalid.pipe';
import {IsSpecVisibilityInvalidPipe} from "./spec/spec-lines-edit/is-spec-visibility-invalid.pipe";
import {IsExpressionEmptyPipe} from "./spec/spec-lines-edit/is-expression-empty.pipe";



@NgModule({
  declarations: [
    ContactEditModalComponent,
    ContactListComponent,
    HierarchyNodeEditModalComponent,
    SpecLinesEditComponent,
    FilterAndGroupAndSortSpecsPipe,
    IsSpecWithLocalizationsPipe,
    IsSpecDuplicatePipe,
    IsSpecValueInvalidPipe,
    IsSpecVisibilityInvalidPipe,
    IsExpressionEmptyPipe,
    PropertyMappingEditorModalComponent,
    LocalizationListComponent,
    LocalizationEditComponent,
    ConfirmFinalModificationModalComponent,
  ],
  imports: [
    CommonModule,
    CommonSharedModule,
    SystemModule,
    CheckboxModule,
    FormsModule,
    TranslocoModule,
    NgArrayPipesModule,
    TableModule,
    NgbDropdownModule,
    MesCommonModule,
    InlineSVGModule,
    NgSelectModule,
    ActionBarModule,
  ],
  exports: [
    LocalizationListComponent,
    SpecLinesEditComponent,
  ]
})
export class ImeCommonModule { }
